module.exports = __webpack_public_path__ + "static/img/pin-landing-rate-scheduled.a8a7124.svg";